import type { ValueOf } from '../util/typeUtils';

export const WABA_RESOLVERS = {
    getWhatsAppTemplates: 'getWhatsAppTemplates',
} as const;

export type WABA_RESOLVER = ValueOf<typeof WABA_RESOLVERS>;
